const breadcrumbNameMap: Record<string, string> = {
  "/": "Головна",
  "/ordersStatistic": "Статистика замовлень",
  "/orders": "Замовлення",
  "/history": "Історія",
  "/clients": "Клієнти",
  "/drivers": "Водії",
  "/tariffs": "Тарифи",
  "/discount": "Програма лояльності",
  "/newsletters": "Розсилки",
};

export default breadcrumbNameMap;
